import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-481a0868"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "sale-note-left-div",
  style: {"float":"left"}
}
const _hoisted_2 = { id: "tblUserLeft" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Menu")
], -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "inq-a-link" }, "TOP", -1 /* HOISTED */))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "inq-a-link" }, "Issue Sales Note", -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "inq-a-link" }, "Confirm Sales Note", -1 /* HOISTED */))
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "inq-a-link" }, "Master Maintenance", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("tr", null, [
        _createElementVNode("td", null, [
          _createVNode(_component_router_link, { to: "/KDP_SalesNote" }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1 /* STABLE */
          })
        ])
      ]),
      ($setup.store.getters.stationCode == '1000')
        ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
            _createElementVNode("td", null, [
              _createVNode(_component_router_link, { to: "/KDPIssueSalesNote" }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1 /* STABLE */
              })
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("tr", null, [
        _createElementVNode("td", null, [
          _createVNode(_component_router_link, { to: "/KDPConfirmSalesNote" }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1 /* STABLE */
          })
        ])
      ]),
      ($setup.store.getters.stationCode == '1000')
        ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
            _createElementVNode("td", null, [
              _createVNode(_component_router_link, { to: "/MasterMaintenance" }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1 /* STABLE */
              })
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}